import { trackUploadBehavior } from '~/utils/report';

export default defineNuxtRouteMiddleware(async (to, from) => {
  // SSR 环境下不执行路由历史记录和布局设置，避免持有 Vue 实例引用
  if (import.meta.server) {
    return;
  }

  const historyStore = useRouteHistory();
  const { $isPure } = useNuxtApp();

  trackUploadBehavior(to.path);

  /** 首次进入没有name */
  if (from.name) {
    historyStore.value.push({
      name: from.name,
      path: from.path,
      fullPath: from.fullPath,
      query: from.query as unknown as Record<string, string | null>,
      params: from.params as unknown as Record<string, string>,
    });
  }

  if (to.name === 'login') {
    setPageLayout($isPure ? false : 'empty');
  }
});
